import React from 'react';
import { TrendingUp, Users, Smile } from 'lucide-react';
import { useModal } from '../contexts/ModalContext';

const Results: React.FC = () => {
  const { handleBookNowClick } = useModal();
  
  return (
    <section className="py-16 bg-black text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            The Results Speak for Themselves
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what happens when salons switch to Zylu:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="text-center">
            <div className="bg-red-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <TrendingUp className="h-10 w-10 text-white" />
            </div>
                            <div className="text-5xl font-bold text-red-500 mb-4">28%</div>
            <h3 className="text-2xl font-bold mb-4">More Revenue</h3>
            <p className="text-gray-300 leading-relaxed">
              Average revenue increase within the first 6 months of using Zylu's 
              automated booking and marketing system.
            </p>
          </div>

          <div className="text-center">
            <div className="bg-red-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <Users className="h-10 w-10 text-white" />
            </div>
            <div className="text-5xl font-bold text-red-500 mb-4">4-5x</div>
            <h3 className="text-2xl font-bold mb-4">Higher Retention</h3>
            <p className="text-gray-300 leading-relaxed">
              Customer retention rates improve dramatically with automated follow-ups 
              and personalized loyalty programs.
            </p>
          </div>

          <div className="text-center">
            <div className="bg-red-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <Smile className="h-10 w-10 text-white" />
            </div>
            <div className="text-5xl font-bold text-red-500 mb-4">46%</div>
            <h3 className="text-2xl font-bold mb-4">Better Employee Engagement</h3>
            <p className="text-gray-300 leading-relaxed">
              Staff satisfaction increases when they can focus on customers instead 
              of manual administrative tasks.
            </p>
          </div>
        </div>

        <div className="bg-red-900 rounded-2xl p-8 text-center">
          <h3 className="text-3xl font-bold mb-4">
            Ready to Join Thousands of Successful Salon Owners?
          </h3>
          <p className="text-xl text-red-100 mb-6">
            Stop leaving money on the table. Your competitors are already automating their success.
          </p>
          <p className="text-lg text-red-200 mb-8">
            The question isn't whether you can afford Zylu—it's whether you can afford NOT to use it.
          </p>
          <button
            onClick={handleBookNowClick}
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl text-xl"
          >
            Book Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default Results;